import React, { useState, useEffect } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
//import CrudService from '../../../../services/crudService'

//import Pagination from "../../Pagination";
import { NumericFormat } from 'react-number-format';

const documentTypes = [
    { id: 1, name: 'Road Inspection Certificate' },
    { id: 2, name: 'Authorization Letter' },
    { id: 3, name: 'Recycle Ticket' },
    { id: 4, name: 'Company Automobile liability Insurance' },
    { id: 5, name: 'Seal Certificate' },
    { id: 6, name: 'Purchase Invoice' }
];

const DocTabContent = ({ data, handleViewReport }) => {
    /*
    <option value="1">Road Inspection Certificate</option>
    <option value="2">Authorization Letter</option>
    <option value="3">Recycle Ticket</option>
    <option value="4">Company Automobile liability Insurance</option>
    <option value="5">Seal Certificate</option>
    <option value="6">Purchase Invoice</option>
    */

    function GetDocumentType(typeId) {
        const obj_ = documentTypes.find(obj => obj.id == typeId);
        return obj_ ? obj_.name : null;
    }

	return (
		<>
			<div className="row">
				<div className="col-lg-12">
                    <h4 className="title mb30">Documents</h4>
				</div>
				{/* <!-- Tab panes --> */}

				<div className="col-lg-12">
					<div className="tab-content row" id="nav-tabContent">
						<div
							className="tab-pane fade show active"
							id="nav-home"
							role="tabpanel"
							aria-labelledby="nav-home-tab"
						>
                            {/* Detail Table */}
							<div className="col-lg-12">
                                <div className="table-responsive my_lisging_table">
                                    <table className="table">
                                        <thead className="table-light">
                                            <tr className="thead_row">
                                                <th className="thead_title pl20" scope="col">
                                                    Type / Description
                                                </th>
                                                <th className="thead_title" scope="col">
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* End thead */}

                                        <tbody>
                                            {data?.map((item) => (
                                                <tr key={item.id}>
                                                    <td className="align-middle">{GetDocumentType(item.type)}</td> 
                                                    <td className="editing_list align-middle">
                                                        <ul>
                                                            <li className="list-inline-item mb-1">
                                                                {/* <NavLink exact to={null} className={'text-primary'} title="View" onClick={(e) => handleViewReport(e, 1)}><span className="flaticon-view"></span></NavLink> */}
                                                                <button className={'text-primary'} title="Download Document" onClick={(e) => handleViewReport(e, 1, item.ref_no + '_' + GetDocumentType(item.type))}><span className="flaticon-download"></span></button>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* End Detail Table */}
						</div>
						{/* End tab-content */}
					</div>
					{/* End tab-content */}
				</div>
			</div>
		</>
	);
};

export default DocTabContent;
